import type { MasterOp } from '@trackeat/shared';

/** Old tenant printer rows used the device-local size shape. Preserve identity. */
export function normalizeLegacyPrinterMaster(op: MasterOp): MasterOp {
  if (op.table !== 'printers' || !Object.hasOwn(op.patch, 'label_size_mm')) return op;
  const size = op.patch.label_size_mm;
  if (!size || typeof size !== 'object' || Array.isArray(size)) return op;
  const { width, height } = size as Record<string, unknown>;
  if (
    typeof width !== 'number' || !Number.isFinite(width) || width <= 0
    || typeof height !== 'number' || !Number.isFinite(height) || height <= 0
    || Object.keys(size).some((key) => key !== 'width' && key !== 'height')
    || (op.patch.label_width_mm !== undefined && op.patch.label_width_mm !== width)
    || (op.patch.label_height_mm !== undefined && op.patch.label_height_mm !== height)
  ) return op;
  const patch = { ...op.patch };
  delete patch.label_size_mm;
  return { ...op, patch: { ...patch, label_width_mm: width, label_height_mm: height } };
}
